// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__3li7f","info":"Note_info__2naK9","note":"Note_note__w-Cig","actions":"Note_actions__cJh9g"};